define([
	"dijit/form/ToggleButton",
	"./_Plugin",
	"./PluginFactory"
], function(ToggleButton,_Plugin,PluginFactory) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		fill: false,
		"class": "csi-button-toggle",
		iconClass: "csiActionIcon svgIconPen",
		pluginName: "pen",
		title: "CanvasPen",
		tagShape: "path",

		/**
		 * Enable and disable the curve mode
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set("checked", this.editor.isEditPenMode() || this.editor.isDrawMode(this.pluginName))
			return true;
		},

		/**
		 * Invoke draw custom shape action
		 */
		onClick: function() {
			// Set draw mode without shape tool.
			this.editor.setDrawMode("pen");
		}
	});
});
